import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaRegPlayCircle } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import { getMovie } from '../../redux/playMovie';
// import { addMyList } from '../../redux/myList';
import { showMyList } from '../../redux/showMyList';
import loader from '../../assets/loader.gif';

const MovieMain = () => {
  const [movie, setMovie] = useState([]);

  const dispatch = useDispatch();

  const topRated = useSelector((state) => state.topRated);
  const trending = useSelector((state) => state.trending);
  const action = useSelector((state) => state.action);
  const comedy = useSelector((state) => state.comedy);
  const horror = useSelector((state) => state.horror);
  const romance = useSelector((state) => state.romance);
  const animation = useSelector((state) => state.animation);
  const history = useSelector((state) => state.history);

  const location = useLocation();

  let allMovies;

  if (Array.isArray(trending.results)) {
    allMovies = topRated.results.concat(trending.results,
      action.results, comedy.results, horror.results, romance.results,
      animation.results, history.results);
  } else {
    allMovies = [{
      adult: false,
      backdrop_path: '/h8gHn0OzBoaefsYseUByqsmEDMY.jpg',
      genre_ids: [28, 53, 80],
      id: 603692,
      original_language: 'en',
      original_title: 'John Wick: Chapter 4',
      overview: 'With the price on his head ever increasing, John Wick uncovers a path to defeating The High Table. But before he can earn his freedom, Wick must face off against a new enemy with powerful alliances across the globe and forces that turn old friends into foes.',
      popularity: 3911.607,
      poster_path: '/vZloFAK7NmvMGKE7VkF5UHaz0I.jpg',
      release_date: '2023-03-22',
      title: 'John Wick: Chapter 4',
      video: false,
      vote_average: 7.9,
      vote_count: 2828,
    }];
  }
  const moviesWithUrls = allMovies.filter((mov) => mov.backdrop_path !== null);

  useEffect(() => {
    setMovie(
      moviesWithUrls[
        Math.floor(Math.random() * moviesWithUrls.length - 1)
      ],
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, dispatch]);

  function truncate(str, n) {
    return str?.length > n ? `${str.substr(0, n - 1)}...` : str;
  }

  const handleClick = (movie) => {
    const play = true;
    const playMovieProps = { movie, play };
    dispatch(getMovie(playMovieProps));
    // if (movie) {
    //   dispatch(addMyList(movie));
    // }
  };

  const showList = () => {
    const showMyListState = { showList: true };
    dispatch(showMyList(showMyListState));
  };

  return (
    <>
      {movie ? (
        <div
          className="home-movie"
          style={{
            backgroundSize: 'cover',
            backgroundImage: `url("https://image.tmdb.org/t/p/original/${movie?.backdrop_path}")`,
            backgroundPosition: 'center center',
          }}
        >
          <div className="home-movie-contents">
            <h1 className="home-movie-title">
              {movie?.title || movie?.name || movie?.original_name}
            </h1>
            <div className="home-movie-buttons">
              <button className="home-movie-button play-btn" type="button" onClick={() => handleClick(movie)}>
                <span>Play</span>
                <FaRegPlayCircle />
              </button>
              <button className="home-movie-button" type="button" onClick={() => showList()}>My List</button>
            </div>
            <p className="home-movie-description">
              {truncate(movie?.overview, 150)}
            </p>
          </div>
          <div className="home-movie--fadeBottom" />
        </div>
      ) : (
        <div className="pop-movie-loader-section">
          <img src={loader} className="pop-movie-loader" alt="FlixFrenzy" />
        </div>
      )}
      <div />
    </>
  );
};

export default MovieMain;
